<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
      <Nav curNavId="8" pathUrl='suyuan' />
    <div class="content">
      <div class="left">
        <div class="leftBox1">
          <div class="title">近3年上蔡县小麦种植情况</div>
          <div class="echarts"><LeftBar :listData="state.leftbar" /></div>
        </div>
        <div class="leftBox2">
          <div class="title">上蔡县小麦育种情况</div>
          <div class="leftBox2Info">
            <div class="txt1Box">
              <div class="txt1Item" v-for="(item,index) in state.leftTxt1" :key="index">{{item}}</div>
            </div>
            <div class="txt2Box">
              <div class="txt2Item" v-for="(item,index) in state.leftTxt2" :key="index"><span>{{item.title}}</span><span>{{item.txt}}</span></div>
            </div>
            <div class="txt1Box">
              <div class="txt1Item" v-for="(item,index) in state.leftTxt3" :key="index">{{item}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="videoBox"></div>
        <div class="centerBox1">
          <div class="title">近3年上蔡县小麦产量情况</div>
          <div class="titleList"><span v-for="(item,index) in state.centerLine" :key="index" :class="{cur:state.centerLineIndex==index}" @click="tabCl(index)">{{item.name}}</span></div>
          <div class="echarts" v-if="state.showDiv"><CenterLine :listData="state.centerLine[state.centerLineIndex].list" /></div>
        </div>
      </div>
      <div class="right">
        <div class="rightBox1">
          <div class="title">近三年上蔡县农特产品加工企业各类原料面粉需求情况</div>
          <div class="echarts"><RightBar :listData="state.rightbar" /></div>
        </div>
        <div class="rightBox2">
          <div class="title">未来三年上蔡县优质小麦种植结构调整计划</div>
          <div class="rightInfo2">
            <div class="info1">
              <div class="info1Item" v-for="(item,index) in state.rightData1">
                <div class="imgBox"><img src="../assets/img/plantfx1/qj.png" /><span>{{item.value}}</span></div>
                <span class="txt">{{item.name}}</span>
              </div>
            </div>
            <div class="info2">
              <div class="info2Item" v-for="(item,index) in state.rightData2">
                <img :src="item.icon" />
                <span :style="{color:item.color}">{{item.txt}}</span>
              </div>
            </div>
            <div class="info3">{{state.righttxt}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">本产品由来村网提供技术支持</div>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";
import LeftBar from "@/components/plantfx1/leftBar"
import RightBar from "@/components/plantfx1/rightBar"
import CenterLine from "@/components/plantfx1/centerLine"
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import Nav from "../components/nav.vue";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";
  // const timer = ref(null);
  const router = useRouter();

  const state = reactive({
    leftTxt1:["上蔡县共有民办非企业育种单位2个，分别是上蔡县创新农 业科学技术研究开发中心和上蔡县亿麦轩小麦研究所。","2018-2023年共有6个小麦新品种获得了国家和省级审定"],
    leftTxt2:[{title:"通过国家审定：",txt:"“轮选禧麦1号” "},{title:"通过河南省审定：",txt:"“轮选88”“ 轮选122”“轮选125” “轮选130”“戚丰5号” "}],
    leftTxt3:["10个品系正在参加国家和省试验","“十四五”期间，将有三个小麦新品种分别通过国家和省级审定。 "],
    leftbar:{
      time:['2021', '2022', '2023'],
      list:[
        {
          name: '强筋',
          value: [82, 85, 85]
        },
        {
          name: '中筋',
          value: [62, 62, 67]
        },
        {
          name: '弱筋',
          value: [46, 46, 46],
        },
      ]
    },
    centerLine:[
      {name:"强筋", list:{time:['2021', '2022', '2023'],value:[47.55,51.32,46.4]}},
      {name:"中筋",list:{time:['2021', '2022', '2023'],value:[35.72,35.98,36.3]}},
      {name:"弱筋",list:{time:['2021', '2022', '2023'],value:[27.55,28.56,29.63]}}
    ],
    centerLineIndex:0,
    showDiv:true,
     rightbar:{
      time:['2021', '2022', '2023'],
      list:[
        {
          name: '强筋',
          value: [120, 75, 90]
        },
        {
          name: '中筋',
          value: [102, 130, 75]
        },
        {
          name: '弱筋',
          value: [200, 130, 75],
        },
        {
          name: '其他面粉（绿小麦、黑小麦）',
          value: [200, 130, 75],
        },
      ]
    },
    rightData1:[
      {name:"强筋小麦种植(亩)",value:'XX'},
      {name:"中筋小麦种植",value:'XX'},
      {name:"弱筋小麦种植",value:'XX'},
      {name:"其他小麦 （绿小麦、黑小麦）",value:'XX'},
    ],
    rightData2:[
      {txt:"引进小麦院士工作站1个",icon:require('../assets/img/plantfx1/yj(1).png'),color:"#53EA8C"},
      {txt:"培育弱筋小麦新品种2个",icon:require('../assets/img/plantfx1/py.png'),color:"#F5E81C"},
    ],
    righttxt:"预计小麦产业整体增收XX%。",
    config: {
      header: [
        '<span style="color:#fff;">抽检时间</span>',
        '<span style="color:#fff;">品种</span>',
        '<span style="color:#fff;">批次</span>',
        '<span style="color:#fff;">基数</span>',
        '<span style="color:#fff;">合格率</span>',
      ],

      data: [
        ["2024.3.1", "小麦", "20230301BATCH001", "30", "100%"],
        ["2024.3.1", "玉米", "20230301BATCH001", "30", "100%"],
        ["2024.3.1", "大豆", "20230301BATCH001", "30", "100%"],
        ["2024.3.1", "花生", "20230301BATCH001", "30", "100%"],
        ["2024.3.1", "小麦", "20230301BATCH001", "30", "100%"],
        ["2024.3.1", "花生", "20230301BATCH001", "30", "100%"],
        ["2024.3.1", "大豆", "20230301BATCH001", "30", "100%"],
        ["2024.3.1", "小麦", "20230301BATCH001", "30", "100%"],
      ],
      headerBGC: "#04585E",
      oddRowBGC: "",
      evenRowBGC: "",
      index: false,
      columnWidth: [120],
      align: ["center"],
      // rowNum:6
    },
  });
function tabCl(index){
  console.log(index)
  state.showDiv = false; // 点击后先隐藏div
  state.centerLineIndex = index
  setTimeout(() => {
    state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
  }, 200);
}
  // 在 onMounted 中初始化地图
  onMounted(() => {});


  onUnmounted(() => {});
  onBeforeUnmount(() => {
    // clearInterval(timer.value);
  });
</script>
<style lang="less" scoped>
 .footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 14px;
    position: fixed;
    bottom: 20px;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
body {
  background-size: cover;
  line-height: 1.15;
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  background: #030A0C;
  .title{
    width:100%;
    height: 40px;
    font-weight: bold;
    background: url("../assets/img/plantfx1/bt1.png") no-repeat left bottom;
    color: #fff;
    font-size: 20px;
    line-height: 20px;
    text-align: left;
    padding-left: 30px;
  }
  .content{
    width: 100%;
    height:calc(100vh - 88px);
    padding-top: 50px;
    display: flex;
    .echarts{
      width: 100%;
      flex: 1;
    }
    .left{
      width: 546px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .leftBox1{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .leftBox2{
        width: 100%;
        height: 560px;
        display: flex;
        flex-direction: column;
        .leftBox2Info{
          padding: 43px 30px 60px 18px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .txt1Box{
            .txt1Item{
              background: url("../assets/img/plantfx1/sc.png") no-repeat left 2px;
              padding-left: 30px;
              color: #fff;
              font-size: 16px;
              margin-bottom: 40px;
              text-align: left;
              //font-weight: bold;
              line-height:26px;
            }
          }
          .txt2Box{
            width: 100%;
            height: 74px;
            background: url("../assets/img/plantfx1/tg.png") no-repeat;
            margin-bottom: 30px;
            .txt2Item{
              line-height: 36px;
              font-size: 14px;
              color: #fff;
              text-align: left;
              padding: 0 30px 0 30px;
            }
            .txt2Item:first-child{
              span:last-child{
                color: #1BDDE3;
              }
            }
            .txt2Item:last-child{
              span:last-child{
                color: #BAB350;
              }
            }

          }
        }
      }
    }
    .center{
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      .videoBox{
        width: 100%;
        height: 541px;
        background: url("../assets/img/plantfx1/spk.png") no-repeat;
      }
      .centerBox1{
        width: 100%;
        flex: 1;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        padding-bottom: 50px;
        position: relative;
        .titleList{
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          span{
            display: block;
            width: 66px;
            height: 26px;
            font-size: 14px;
            color: #fff;
            line-height: 26px;
            margin-right: 10px;
            box-shadow: inset 0 0 14px rgba(0, 121, 107, 0.8);
            cursor: pointer;
          }
          span.cur{
            background:#00796B ;
          }
        }

      }
    }
    .right{
      width: 570px;
      height: 100%;
      padding: 0 0 0 50px;
      .rightBox1{
        width: 100%;
        height: 360px;
        display: flex;
        flex-direction: column;
      }
      .rightBox2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .rightInfo2{
          width: 100%;
          flex: 1;
          .info1{
            display: flex;
            flex-wrap: wrap;
            .info1Item{
              width: 50%;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin:20px 0;
              .imgBox{
                width: 112px;
                height: 72px;
                position: relative;
                img{
                  width: 100%;
                  height: 100%;
                }
                span{
                  display: block;
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  text-align: center;
                  font-size: 18px;
                  background: linear-gradient(to bottom,#FFFFFF 0%, #50E5D2 20%);
                  //background: linear-gradient(to right, #ff0000, #ffff00); /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
                  -webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
                  -webkit-text-fill-color: transparent;/*给文字设置成透明*/
                }
              }
              .txt{
                width: 130px;
                color: #fff;
                font-size: 16px;
              }
            }
          }
          .info2{
            display: flex;
            .info2Item{
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              img{
                width: 66px;
                height: 50px;
              }
              span{
                color: #fff;
                font-size: 16px;
                margin-top: 10px;
              }
            }
          }
          .info3{
            background: url("../assets/img/plantfx1/yj.png") no-repeat;
            color: #fff;
            width: 100%;
            height: 43px;
            line-height: 43px;
            margin: 30px 0 0;
            text-align: left;
            font-size: 20px;
            padding-left: 50px;
          }
        }
      }
    }
  }
  }

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
